<a class="cu-list-entry-container flex items-center"
   routerLinkActive="active-entry"
   [class.grayed-out]="isUsed()"
   [routerLink]="isEditMode() ? null : ['/content-unit', item().uuid]"
   [title]="item().title"
   (click)="onEntryClick()"
>

  <div class="cu-link flex flex-col flex-1 overflow-hidden">
    <span class="truncate cu-link-title">{{ item().title }}</span>
    <span class="truncate cu-link-description">{{ item().description }}</span>
    <div class="cu-tags-container card pt-2.5">
      @for (tag of item().tags; track tag) {
        <p-tag [value]="tag"/>
      }
    </div>
  </div>

  @if (isEditMode()) {
    <button pButton
            type="button"
            iconOnly
            [attr.data-test]="'add-cu-' + item().uuid"
            [disabled]="isUsed()"
            [text]="true"
            [title]="isUsed() ? 'Already added' : 'Add to template'"
            (click)="onAddClick($event)"
    >
      <i class="pi pi-chevron-right"></i>
    </button>
  }
</a>
